import { EXPERIENCE_IDS } from '@/components/admin/experiences/contracts';
import { CONVERSATION_LABEL } from '@/lib/experience-labels';
import { cn } from '@/lib/utils';
import { MessageCircle } from 'lucide-react';

/**
 * La pastille « Conversation » d'une page jouée dans le fil (prolongation.md §6 ;
 * planche `editeur.html`, choix P9 a ; issue #186).
 *
 * Au patron exact de `feedback-badge` - « Retour », jaune -, en bleu nuit, la
 * couleur de la page protocole : c'est le protocole qui se prolonge, donc c'est sa
 * couleur qui marque les pages qui en font partie. Quatre emplacements, UN
 * dessin :
 *
 * - `label` - à côté du nom, sous la page du centre, dans le libellé d'une
 *   pastille du rail et dans la ligne de position du bandeau de page ;
 * - `frame` - posée dans le coin haut gauche d'une vignette voisine.
 *
 * Le texte « Conversation » est le nom accessible : l'icône, elle, ne dit rien.
 */

export interface ConversationBadgeProps {
  readonly placement?: 'label' | 'frame';
  /** Sur une pastille du rail PLEINE (la page courante) : la pastille se détache en blanc. */
  readonly onFilled?: boolean;
  readonly className?: string;
}

export function ConversationBadge({
  placement = 'label',
  onFilled = false,
  className,
}: ConversationBadgeProps) {
  return (
    <span
      data-testid={EXPERIENCE_IDS.conversationBadge}
      className={cn(
        'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-pill font-semibold text-bleu-nuit ring-1 ring-bleu-nuit/25 ring-inset',
        onFilled ? 'bg-white' : 'bg-bleu-nuit-tint',
        placement === 'frame'
          ? 'absolute top-1.5 left-1.5 z-10 py-0 pr-1.5 pl-1 text-[11px] leading-4'
          : 'py-0.5 pr-2.5 pl-2 text-xs leading-4',
        className,
      )}
    >
      <MessageCircle aria-hidden="true" className="size-3" />
      {CONVERSATION_LABEL}
    </span>
  );
}
